"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lookup = void 0;
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var ErrorMessage_1 = require("../ErrorMessage");
var HelpText_1 = require("../HelpText");
var Icon_1 = require("../Icon");
var initialState = {
    activeSuggestionIndex: -1,
    suggestions: [],
};
var timerId;
var debounced = function (fn, delay) {
    return function (query) {
        if (timerId) {
            clearTimeout(timerId);
        }
        timerId = setTimeout(function () {
            fn(query);
            timerId = null;
        }, delay);
    };
};
var Lookup = function (props) {
    var _a;
    var id = props.id, label = props.label;
    var _b = React.useState(initialState), state = _b[0], setState = _b[1];
    var _c = React.useState(''), filter = _c[0], setFilter = _c[1];
    var _d = React.useState(false), hideSuggestions = _d[0], setHideSuggestions = _d[1];
    var updateState = function (update) {
        setState(__assign(__assign({}, state), update));
    };
    var wrapperRef = React.useRef(null);
    var inputRef = React.useRef(null);
    var minLength = props.minFilterLength || 4;
    var needsToClear = function (str) { return (!str.length || str.length < minLength) && state.suggestions.length > 0; };
    var filterChanged = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var query;
        return __generator(this, function (_a) {
            query = typeof e === 'string' ? e : e.target.value;
            setFilter(query);
            debounced(function (str) { return __awaiter(void 0, void 0, void 0, function () {
                var result, _a, suggestions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(str.length >= minLength)) return [3 /*break*/, 2];
                            return [4 /*yield*/, props.onChange(str)];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            _a = [];
                            _b.label = 3;
                        case 3:
                            result = _a;
                            if (needsToClear(str) && props.onClear) {
                                props.onClear();
                            }
                            suggestions = props.maxOptions && (result === null || result === void 0 ? void 0 : result.length) > props.maxOptions ? result.slice(0, props.maxOptions) : result;
                            updateState({ suggestions: suggestions, activeSuggestionIndex: -1 });
                            setHideSuggestions(false);
                            return [2 /*return*/];
                    }
                });
            }); }, props.debounceTime === undefined ? 300 : props.debounceTime)(query.trim());
            return [2 /*return*/];
        });
    }); };
    var select = function (suggestion) {
        var selection = suggestion || state.suggestions[state.activeSuggestionIndex];
        var index = -1;
        for (var i = 0; i < state.suggestions.length; i++) {
            if (state.suggestions[i] === selection) {
                index = i;
                break;
            }
        }
        props.onSelect(index);
        setFilter(selection);
        updateState({ suggestions: [selection], activeSuggestionIndex: 0 });
        setHideSuggestions(true);
    };
    var clearBtnClick = function () {
        filterChanged('');
        updateState({ suggestions: [], activeSuggestionIndex: -1 });
        if (props.onClear) {
            props.onClear();
        }
        // istanbul ignore next
        if (inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    };
    var focus = function () {
        setHideSuggestions(false);
    };
    var cancel = function () {
        setHideSuggestions(true);
        if (props.onCancel && filter && wrapperRef && wrapperRef.current && wrapperRef.current.offsetParent) {
            props.onCancel();
        }
    };
    var handler = function (e) {
        if (wrapperRef && wrapperRef.current && !wrapperRef.current.contains(e.target)) {
            cancel();
            return;
        }
        if (e.key) {
            var index = state.activeSuggestionIndex;
            switch (e.key) {
                case 'Up':
                case 'ArrowUp':
                    index--;
                    break;
                case 'Down':
                case 'ArrowDown':
                    index++;
                    break;
                case 'Enter':
                    if (state.activeSuggestionIndex >= 0) {
                        select();
                    }
                    return;
                case 'Esc':
                case 'Escape':
                    cancel();
                    return;
            }
            if (index !== state.activeSuggestionIndex) {
                var min = 0;
                var max = state.suggestions.length - 1;
                if (index < min) {
                    index = max;
                }
                else if (index > max) {
                    index = min;
                }
                updateState({ activeSuggestionIndex: index });
            }
        }
    };
    useEventListener('keyup', handler);
    useEventListener('mouseup', handler);
    var dropExpanded = !hideSuggestions && !!filter && filter.trim().length >= minLength;
    var listId = props.id + "-list";
    return (React.createElement("div", { className: "lookup form-group", ref: wrapperRef },
        label && React.createElement("label", { htmlFor: id }, label),
        React.createElement("div", { className: "input-holder" },
            React.createElement("input", { "aria-activedescendant": listId + "-" + state.activeSuggestionIndex, "aria-autocomplete": "list", "aria-controls": listId, "aria-expanded": dropExpanded, "aria-describedby": props.isValid === false ? props.id + "-errormessage" : props.id + "-helptext", "aria-invalid": props.isValid === false, autoComplete: "off", className: (0, classnames_1.default)('form-control', { 'is-invalid': props.isValid === false }), id: id, maxLength: 1000, onChange: filterChanged, onFocus: focus, ref: inputRef, role: "combobox", type: "text", value: filter }),
            React.createElement(Icon_1.Icon, { "aria-label": "clear", className: "clear", hidden: !filter, onClick: clearBtnClick, symbol: "controlClose24" }),
            props.icon && React.createElement(Icon_1.Icon, { hidden: filter, symbol: props.icon }),
            React.createElement("ul", { className: "lookup__dropdown", id: listId, role: "listbox", hidden: !dropExpanded }, (_a = state.suggestions) === null || _a === void 0 ? void 0 :
                _a.map(function (suggestion, index) { return (React.createElement("li", { "aria-selected": state.activeSuggestionIndex === index, className: (0, classnames_1.default)('lookup__dropdown__item', { 'lookup__dropdown__item--selected': state.activeSuggestionIndex === index }), id: listId + "-" + index, key: index, role: "option", value: suggestion, 
                    // tslint:disable-next-line jsx-no-lambda
                    onClick: function () { return select(suggestion); } }, suggestion)); }),
                props.customItem && React.createElement("li", { className: "lookup__dropdown__item" }, props.customItem))),
        props.isValid !== false && props.helptext && (React.createElement(HelpText_1.HelpText, { id: "" + props.id }, props.helptext)),
        props.isValid === false && props.errormessage && (React.createElement(ErrorMessage_1.ErrorMessage, { id: "" + props.id, message: props.errormessage }))));
};
exports.Lookup = Lookup;
var useEventListener = function (eventName, handler) {
    var savedHandler = React.useRef();
    React.useEffect(function () {
        savedHandler.current = handler;
    }, [handler]);
    React.useEffect(function () {
        var eventListener = function (event) { return savedHandler.current(event); };
        document.addEventListener(eventName, eventListener);
        return function () {
            document.removeEventListener(eventName, eventListener);
        };
    }, [eventName]);
};
exports.Lookup.propTypes = {
    customItem: PropTypes.any,
    debounceTime: PropTypes.number,
    errormessage: PropTypes.string,
    helptext: PropTypes.string,
    icon: PropTypes.string,
    id: PropTypes.string.isRequired,
    isValid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    maxOptions: PropTypes.number,
    minFilterLength: PropTypes.number,
    onCancel: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func,
    onSelect: PropTypes.func.isRequired,
};
